import styled from "styled-components";

export const Container = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #465eb6;
    color: #fff;
    border: none;
    min-width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s;

    :hover {
        background-color: #5b71be;
    }

    :disabled {
        background-color: #c4c4c4;
        cursor: not-allowed;
    }
`;
